import React from "react";
import landing from "@/content/landing";
import { Section } from "./HeroSection";

/**
 * BrandMessage — Markenmanifest zwischen Hero und Story.
 * Hero-H1 bleibt einziges H1 der Seite. Manifest ist semantisch H2,
 * visuell aber dominant wie ein Markensatz.
 */
export default function BrandMessage() {
  const t = landing.brandMessage;
  return (
    <Section
      id="brand-message"
      className="bg-ag-paper relative overflow-hidden"
      data-testid="landing-brand-message"
      aria-label="Markenbotschaft"
    >
      {/* Sehr dezente warme Ambience, damit das Manifest ruhig wirkt */}
      <div
        className="ag-gold-ambient"
        style={{ width: 460, height: 460, top: -140, left: "50%", transform: "translateX(-50%)", opacity: 0.18 }}
        aria-hidden="true"
      />

      <div className="relative mx-auto max-w-3xl text-center">
        <div
          className="mx-auto mb-8 h-px w-16 bg-amber-500/70 sm:w-20"
          aria-hidden="true"
        />

        <h2
          className="ag-brand-manifest font-serif text-ag-ink"
          data-testid="landing-brand-message-manifest"
        >
          {t.manifest}
        </h2>

        <p
          className="mt-8 font-serif italic text-slate-700 text-lg leading-relaxed sm:mt-10 sm:text-xl lg:text-2xl"
          data-testid="landing-brand-message-platform"
        >
          {t.platform}
        </p>

        <p
          className="mt-4 text-sm leading-relaxed text-slate-500 sm:mt-5 sm:text-base"
          data-testid="landing-brand-message-pillars"
        >
          {t.pillars}
        </p>
      </div>
    </Section>
  );
}
